/*
 *
 * File JS block masonry
 *
 */

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import "./block-masonry.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockMasonry = () => {
    let allBlockMasonry = document.querySelectorAll(".block-masonry");

    allBlockMasonry.forEach((el, i) => {
        let grid = document.querySelector(".masonry-grid");

        let msnry = new Masonry(grid, {
            itemSelector: ".grid-item",
            columnWidth: ".grid-sizer",
            percentPosition: true,
        });

        imagesLoaded(grid).on("progress", function () {
            // layout Masonry after each image loads
            msnry.layout();
        });
    });
};

export default blockMasonry;

//--------------------------------------------------------------------//
